import ChatHeader from './ChatHeaderContainer';

export default ChatHeader;
